<template>
  <div>
    <div class="my-exam-head">
      <van-dropdown-menu>
        <van-dropdown-item v-model="yId" :options="yearList" @change="yChange" />
        <van-dropdown-item v-model="sId" :options="sessionList" @change="sChange" />
        <van-dropdown-item v-model="pId" :disabled="pId?false:true" :options="pList" @change="selectProgram" />
      </van-dropdown-menu>
      <div class="my-exam-head-card nowrap" v-if="admissionTicketNumber">
        <div class="nowrap">准考证号：<span>{{admissionTicketNumber}}</span></div>
      </div>
    </div>
    <div class="my-exam-body">
      <div v-for="item in list" :key="item.ExamDate" class="list">
        <ul class="list-ul">
          <li v-for="child in item.Subjects" :key="child.SeatNumber" class="list-li">
            <div class="exam-subject nowrap">
              <div class="exam-subject-name nowrap">
                <img :src="require('@/assets/educationAffairs/subject.png')" alt="">
                <span>{{child.SubjectName}}</span>
              </div>
              <div class="exam-subject-number"><span>座位</span>&nbsp;<b>{{child.SeatNumber}}</b></div>
            </div>
            <div class="list-li-exam exam-times nowrap"><i class="iconfont">&#xe608;</i>{{item.ExamDate}}{{child.SubjectExamTime}}</div>
            <div class="list-li-exam exam-address nowrap"><i class="iconfont">&#xe60e;</i>{{child.ExamRoomName}}（{{child.ExamRoomAddress}}）</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name:'myexam',
  data(){
    return {
      pName:'',
      pId:'',
      yId:0,
      sId:0,
      admissionTicketNumber:'',
      pList:[],
      list:[],
      yearList:[
        {
          text:'所有学年',
          value:0,
          children:[
            {
              label:'所有学期',
              value:0
            }
          ]
        }
      ],
      sessionList:[]
    }
  },
  created(){
    this.getSessionNodeList()
  },
  methods:{
    async getSessionNodeList(){//获取学年学期
    this.xy.loading()
      let res = await this.xyapi.get(`${this.xyMApi}/xy/Comm/GetSessionNodeList`, null);
      if(res.success){
        if(res.data.length>0){
          res.data.map(item=>{
            this.yearList.push({
              text:item.label,
              value:item.value,
              children:item.children
            });
          })
        }
        this.sessionList=[{
          text:this.yearList[0].children[0].label,
          value:this.yearList[0].children[0].value
        }]
        if(this.yId!=='' && this.sId!=='') this.getProgramme()
      }
    },
    async getProgramme(){//获取方案
      this.pList=[];
      let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/ArrangeSupervisorExam/GetArrangeSupervisorByStudentMobile`, {
        AcademicYearID: this.yId,
        AcademicSessionID: this.sId,
        IsDateAfter:false
      });
      if(res.success){
        let datas = res.data;
        if(datas.length>0) {
          datas.map(item => {
            this.pList.push({
              text:item.ArrangeSupervisorExamName,
              value:item.ArrangeSupervisorExamID
            })
          })
          this.pId = this.pList[0].value
        }else{
          this.pList=[{
            text:'暂无方案',
            value:0
          }];
          this.pId=0
        }
        this.getExam()//获取考试信息
      }
    },
    async getExam(){//获取考试信息
      this.xy.loading()
      let res = await this.xyapi.post(`${this.$store.state.apiPath}/api/MyExaminationRoom/GetStudentExamRoomByID?ArrangeSupervisorExamID=${this.pId}`,null);
      this.xy.unloading()
      this.list= res.success ? res.data : []
      this.admissionTicketNumber = this.list.length>0?this.list[0].AdmissionTicketNumber:''//准考证号
    },
    yChange(item){//切换学年
      this.sessionList=[];
      for(let i = 0,len = this.yearList.length;i<len;i++){
        if(item===this.yearList[i].value){
          this.yearList[i].children.map(child=>{
            this.sessionList.push({
              text:child.label,
              value:child.value
            })
          })
        }
      }
      this.sId=this.sessionList[0].value
      this.getProgramme()
    },
    sChange(){//切换学期
      this.getProgramme()
    },
    selectProgram(){//切换方案
     this.getExam()
    }
  }
}
</script>
<style lang="less" scoped>
.my-exam-head{
  height: 230px;
  .my-exam-head-flex{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding:30px 50px 0;
    .programme{
      width: 300px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 26px;
      color:#fff;
      background: rgba(35, 97, 211, 1);
      border-radius: 60px;
      padding:15px 20px;
      span{
        padding-right: 16px;
      }
    }
    .history{
      font-size: 26px;
      color: #fff;
    }
  }
  .my-exam-head-card{
    padding:30px 50px 0;
    div{
      width: 100%;
      height: 60px;
      line-height: 60px;
      padding: 0 0.5rem;
      text-align: center;
      color: rgba(255, 255, 255, 1);
      background: #4196ff;
      border-radius: 30px;
      font-size: 26px;
      span{
        font-size: 30px;
      }
    }
  }
}
.my-exam-body{
  width: 90%;
  margin: 0 auto;
  padding: 0 20px 20px;
  .list{
    .list-ul{
      .list-li{
        display: flex;
        flex-flow: column;
        padding: 20px 0 20px 20px;
        margin-bottom: 20px;
        height: 200px;
        margin-top: 10px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 6px 0px rgba(166, 187, 207, 0.3);
        border-radius: 12px;
        position: relative;
        .exam-subject{
          height: 68px;
          display: flex;
          justify-content:space-between;
          align-items: center;
          margin-bottom: 10px;
          .exam-subject-name{
            font-size: 30px;
            font-weight: bold;
            span{
              margin-left: 20px;
            }
          }
          .exam-subject-number{
            background: #ffac4b;
            color: #fff;
            border-radius: 22px 2px 2px 22px;
            padding: 8px 14px;
            span{
              font-size: 22px;
            }
            b{
              font-size: 28px;
            }
          }
        }
        .list-li-exam{
          font-size: 28px;
          margin-bottom: 10px;
          padding-right: 40px;
          .iconfont{
            font-size: 24px;
            margin:0 20px 0 10px;
            color: #ccc;
          }
        }
      }
    }

  }
}
</style>
